import {EmailSubscriptionType} from '../../../grpc_client/grips/protos/email_subscriptions/v1/email_subscription';
import {useUserSessionContext} from '../../../ui/sharedContexts/UserSessionContext';
import useDropTypeFromPath from '../../../utils/hooks/useDropTypeFromPath';
import {useDropsSubscriptionsContext} from '../context/SubscriptionsProvider';
import {IsSubscribedEmailType} from '../types';
import {
  DROP_PATH_TO_TYPE_MAP,
  DROP_TYPE_SUBSCRIPTION_MAP,
} from '../utils/constants';

export const useIsSubscribed = () => {
  const {email} = useUserSessionContext();
  const {guest, ayUser} = useDropsSubscriptionsContext();
  const dropType = DROP_PATH_TO_TYPE_MAP[useDropTypeFromPath()];
  const subscriptionType = DROP_TYPE_SUBSCRIPTION_MAP[dropType];
  return (
    isAyUserSubscribed(email, ayUser, subscriptionType) ||
    isGuestSubscribed(email, guest, subscriptionType)
  );
};

const isAyUserSubscribed = (
  email: string | undefined,
  ayUser: IsSubscribedEmailType | undefined,
  subscriptionType: EmailSubscriptionType,
) => {
  if (!ayUser) {
    return false;
  }

  if (
    ayUser.email === email ||
    Object.values(ayUser.customEmails || {}).find(subscribedDropIds =>
      subscribedDropIds.includes('all'),
    )
  ) {
    if (ayUser.allDrops?.subscribedTypes?.includes(subscriptionType)) {
      return true;
    }
  }

  return false;
};

const isGuestSubscribed = (
  email: string | undefined,
  guest: IsSubscribedEmailType | undefined,
  subscriptionType: EmailSubscriptionType,
) => {
  if (!guest) {
    return false;
  }

  if (email) {
    return false;
  }

  return Boolean(guest.allDrops?.subscribedTypes?.includes(subscriptionType));
};
